import React, { useState, useEffect } from "react";
import config from "../../config";
import axios from "axios";
import {
  Table,
  message,
  Form,
  Input,
  DatePicker,
  Select,
  Pagination,
  Tooltip,
  Button,
  Modal,
  Row,
  Col,
  Space,
  Drawer,
  Tag,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  IdcardOutlined,
  PushpinOutlined,
  EditOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import Map from "../Map";

const PetrolPumps = () => {
  const [loading, setLoading] = useState(false);
  const UserID = localStorage.getItem("AdminID");
  const AccessKey = localStorage.getItem("AdminAccessKey");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [Package, setPackage] = useState("");
  const [PumpCode, setPumpCode] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Name, setName] = useState("");
  const [NozzleSale, setNozzleSale] = useState("");
  const [listOfLedger, setListOdLedger] = useState([]);
  const [ListOfPackages, setListOfPackages] = useState([]);

  // pagination
  const [PageNo, setPageNo] = useState(1);
  const [PageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedPumpID, setSelectedPumpID] = useState(null);
  const [adressLoading, setAddressLoading] = useState(false);
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  // const [open, setOpen] = useState(false);
  const[showDrawer,setShowDrawer]= useState(false)
  const [placement, setPlacement] = useState("right");
  const [PumpID, setPumpID] = useState(0);
  const [profileSaving, setProfileSaving] = useState(false);
  const [listRefreshKey, setListRefreshKey] = useState(0);
  const [leadSummaries, setLeadSummaries] = useState({});

  const [locationForm] = Form.useForm();
  const [profileForm] = Form.useForm();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = (id) => {
    locationForm.setFieldsValue({ PumpID: id, Longitude: "", Latitude: "" });
    setSelectedPumpID(id);
    setIsModalOpen(true);
  };

  const handelOk = () => setIsModalOpen(false);

  const handelCancel = () => {
    locationForm.resetFields();
    setSelectedPumpID("");
    setIsModalOpen(false);
  };

  const showDrawerfn = (id) => {
    setPumpID(id);
    setShowDrawer(true);
  };

  const onClose = () => {
    setShowDrawer(false);
    setPumpID(0);
    profileForm.resetFields();
  };

  useEffect(() => {
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      startDate: startDate,
      endDate: endDate,
      PageNo: PageNo,
      PageSize: PageSize,
      Package: Package,
      PumpCode: PumpCode,
      Email: Email,
      Mobile: Mobile,
      NozzleSale: NozzleSale,
      Name: Name,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetPetrolPumps",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
       
        if (response.data.status_code == 1) {
          setListOdLedger(response.data.listofLedger);
          setTotalRecords(response.data.totalRecords);
          // form.setFieldValue(response.data)

          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        message.error("Network Error");
        console.log(error);
      });
  }, [
    startDate,
    endDate,
    Package,
    PumpCode,
    Email,
    Mobile,
    PageSize,
    PageNo,
    Name,
    listRefreshKey,
  ]);

  useEffect(() => {
    if (!listOfLedger || listOfLedger.length === 0) {
      setLeadSummaries({});
      return;
    }

    const pumpIDs = listOfLedger.map((row) => row.ID);
    axios({
      method: "post",
      url: config.base_url + "PumpLead/GetPumpLeadSummaries",
      headers: { "Content-Type": "application/json" },
      data: { UserID, AccessKey, PumpIDs: pumpIDs },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          const map = {};
          (response.data.listofRecords || []).forEach((item) => {
            map[item.PumpID] = item;
          });
          setLeadSummaries(map);
        }
      })
      .catch(() => {
        /* listing still works without lead summaries */
      });
  }, [listOfLedger, UserID, AccessKey]);

  const leadTagColor = (status) => {
    if (!status) return "default";
    if (["Very Interested", "Converted"].includes(status)) return "green";
    if (["Interested", "Trial Extended"].includes(status)) return "blue";
    if (["Not Interested", "Lost", "Invalid Lead"].includes(status)) return "red";
    if (status === "Already Using Another Software") return "orange";
    return "default";
  };

  const formatLeadDate = (val) =>
    val ? dayjs(val).format(config.date_format) : "—";

  useEffect(() => {
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetPackagesList",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setListOfPackages(
            response.data.ListofRecords.map((item) => ({
              value: item.Name,
              label: item.Name,
            }))
          );
        } else {
          // Handle error
          message.error(response.data.status_message);
        }
      })
      .catch(function (error) {
        message.error("Network Error");
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (PumpID !== 0 && showDrawer) {
      setProfileSaving(true);
      const data = {
        UserID: UserID,
        AccessKey: AccessKey,
        ID: PumpID,
      };

      var api_config = {
        method: "post",
        url: config.base_url + "AdminUser/GetPetrolPumpInfo",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          if (response.data.status_code == 1) {
            const details =
              response.data.PumpDetails ?? response.data.pumpDetails ?? {};
            profileForm.setFieldsValue({
              Name: details.Name ?? details.name ?? "",
              Address: details.Address ?? details.address ?? "",
              Phone: details.Phone ?? details.phone ?? "",
              Fax: details.Fax ?? details.fax ?? "",
              Email: details.Email ?? details.email ?? "",
              Mobile: details.Mobile ?? details.mobile ?? "",
              Website: details.Website ?? details.website ?? "",
            });
          } else {
            message.error(
              response.data.status_message || "Unable to load pump details."
            );
          }
          setProfileSaving(false);
        })
        .catch(function () {
          message.error("Network Error");
          setProfileSaving(false);
        });
    }
  }, [PumpID, showDrawer]);

  const columns = [
    {
      title: "ID",
      dataIndex: "ID",
      key: "ID",
    },
    {
      title: "Pump Code",
      dataIndex: "PumpCode",
      key: "PumpCode",
    },
    {
      title: "Dated",
      dataIndex: "Created_Date",
      key: "Created_Date",
      render: (_, record) =>
        dayjs(record.Created_Date).format(config.date_format),
    },

    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },

    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      key: "Phone",
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      key: "Mobile",
    },
    {
      title: "Type",
      dataIndex: "PackageName",
      key: "PackageName",
    },
    {
      title: "Lead Status",
      key: "LeadStatus",
      width: 140,
      render: (_, record) => {
        const summary = leadSummaries[record.ID];
        return summary?.LeadStatus ? (
          <Tag color={leadTagColor(summary.LeadStatus)}>{summary.LeadStatus}</Tag>
        ) : (
          <Tag>No contact</Tag>
        );
      },
    },
    {
      title: "Next Follow-up",
      key: "NextFollowUpDate",
      width: 120,
      render: (_, record) => formatLeadDate(leadSummaries[record.ID]?.NextFollowUpDate),
    },
    {
      title: "Last Contact",
      key: "LastContactDate",
      width: 120,
      render: (_, record) => formatLeadDate(leadSummaries[record.ID]?.LastContactDate),
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      width: 130,
      render: (_, record) => {
        return (
          <div style={{ textAlign: "center", display: "flex", gap: 10 }}>
            <Tooltip title="Lead Status">
              <NavLink to={`/controlbase/petrolpump/lead/${record.ID}`}>
                <PhoneOutlined />
              </NavLink>
            </Tooltip>
            <Tooltip title="Suspend">
              <DeleteOutlined />
            </Tooltip>
            <Tooltip title="View Detils">
              <NavLink to={`/controlbase/petrolpump/detail/${record.ID}`}>
                <IdcardOutlined />
              </NavLink>
            </Tooltip>
            <Tooltip title="Add Subscription">
              <NavLink
                to={`/controlbase/petrolpump/add-subscription/${record.ID}`}
              >
                <PlusOutlined />
              </NavLink>
            </Tooltip>
            <Tooltip title="Add Location">
              <PushpinOutlined onClick={() => showModal(record.ID)} />
            </Tooltip>
            <Tooltip title="Edit Profile Info">
              <EditOutlined onClick={()=>showDrawerfn(record.ID)} />
            </Tooltip> 
          </div>
        );
      },
    },
  ];

  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  const handleLocationSelect = (lat, lng) => {
    setLatitude(lat);
    setLongitude(lng);
    locationForm.setFieldsValue({ Latitude: lat, Longitude: lng });
  };

  const handelAddressSubmit = (formData) => {
    setAddressLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ...formData,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/UpdatePumpLocation",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          message.success(response.data.status_message);
          locationForm.resetFields();
          setIsModalOpen(false);
          setAddressLoading(false);
          handelCancel();
        } else {
          message.error(response.data.status_message);
          // console.log("Error in API response: ", response.data_status);
        }
      })
      .catch(function (error) {
        message.error("Network Error");
      });
  };

  const { RangePicker } = DatePicker;
  const handleDateChange = (date, value) => {
    setStartDate(value[0]);
    setEndDate(value[1]);
  };
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const handleSearchByCode = (e) => {
    setPumpCode(e.target.value);
  };

  const handleSearchByEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleSearchByMobile = (e) => {
    setMobile(e.target.value);
  };

  const handleSearchByName = (e) => {
    setName(e.target.value);
  };

  const onPageChange = (page, pageSize) => {
    setPageNo(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageNo(1);
    setPageSize(size);
  };

  const handleProfileSubmit = (formData) => {
    if (!PumpID) {
      message.error("No pump selected.");
      return;
    }
    setProfileSaving(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: PumpID,
      Name: formData.Name,
      Address: formData.Address,
      Phone: formData.Phone ?? "",
      Fax: formData.Fax ?? "",
      Email: formData.Email,
      Mobile: formData.Mobile,
      Website: formData.Website ?? "",
    };

    axios({
      method: "post",
      url: config.base_url + "AdminUser/UpdatePetrolPumpProfile",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code == 1) {
          message.success(response.data.status_message);
          onClose();
          setListRefreshKey((k) => k + 1);
        } else {
          message.error(
            response.data.status_message || "Unable to update profile."
          );
        }
        setProfileSaving(false);
      })
      .catch(() => {
        message.error("Network Error");
        setProfileSaving(false);
      });
  };

  return (
    <>
       <Drawer
        title="Change Company Information"
        placement={placement}
        width={500}
        onClose={onClose}
        open={showDrawer}
        destroyOnClose
      >
        <Row>
        <Col md={24}>
        <Form
          form={profileForm}
          name="pumpProfile"
          layout="vertical"
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span:24,
          }}
          onFinish={handleProfileSubmit}
          autoComplete="off"
        >
          
              <Form.Item
                label="Pump Name"
                name="Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter Pump name",
                  },
                ]}
              >
                <Input placeholder="Enter Pump Name" />
              </Form.Item>
              <Form.Item
                label="Address"
                name="Address"
                rules={[
                  {
                    required: true,
                    message: "Please enter Address",
                  },
                ]}
              >
                <Input placeholder="Enter Your Address" />
              </Form.Item>
              <Form.Item label="Phone" name="Phone">
                <Input placeholder="Enter Phone Number" />
              </Form.Item>
              <Form.Item label="Fax" name="Fax">
                <Input placeholder="Enter fax machine" />
              </Form.Item>
             
              <Form.Item
                label="Email"
                name="Email"
                rules={[
                  {
                    required: true,
                    message: "Please enter Email",
                  },
                ]}
              >
                <Input placeholder="Enter Email Address"/>
              </Form.Item>
              <Form.Item
                label="Mobile"
                name="Mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter Mobile No",
                  },
                ]}
              >
                <Input placeholder="Enter Mobile Number" />
              </Form.Item>
              <Form.Item label="Website" name="Website">
                <Input placeholder="Ex. www.petrol-pump.com" />
              </Form.Item>
              <Form.Item>
                <div className="sale-footer">
                  <div className="text-right" style={{ marginTop: "30px" }}>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      htmlType="submit"
                      loading={profileSaving}
                    >
                      Update Information
                    </Button>
                  </div>
                </div>
              </Form.Item>
           
        </Form>
        </Col>
        </Row>
      </Drawer> 
      <div className="right-side-contents">
        <div className="page-content control-base-wrap">
          <div className="page-header">
            <h3 className="page-title">Petrol Pumps</h3>
            <div className="header-actions">
              <NavLink to="/controlbase/addpump">
                <Button
                  type="primary"
                  size="large"
                  shape="round"
                  icon={<PlusOutlined style={{ color: "white" }} />}
                >
                  Add Pump
                </Button>
              </NavLink>
            </div>
          </div>
          <div className="filters-wrap">
            <Form>
              <Form.Item>
                <RangePicker
                  allowClear
                  onChange={handleDateChange}
                  disabledDate={disabledDate}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  placeholder="Name"
                  value={Name}
                  onChange={handleSearchByName}
                />
              </Form.Item>
              <Form.Item>
                <Select
                  allowClear
                  showSearch
                  style={{
                    width: "150px",
                  }}
                  placeholder="Packge"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => setPackage(value)}
                  options={ListOfPackages}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  style={{
                    width: "100px",
                  }}
                  placeholder="Pump Code"
                  value={PumpCode}
                  onChange={handleSearchByCode}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  placeholder="Search By Email"
                  value={Email}
                  onChange={handleSearchByEmail}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  placeholder="Mobile No"
                  value={Mobile}
                  onChange={handleSearchByMobile}
                />
              </Form.Item>
            </Form>
          </div>
          <Table
            size="small"
            scroll={{
              x: "max-content",
            }}
            loading={loading}
            dataSource={listOfLedger}
            columns={columns}
            pagination={false}
            bordered
          />
          <div className="text-end mt-5">
            <Pagination
              current={PageNo}
              pageSize={PageSize}
              size="small"
              total={totalRecords}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange}
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>

      <Modal
        title="Add Location"
        open={isModalOpen}
        onCancel={handelCancel}
        footer={null}
        destroyOnClose
      >
        <Row>
          <Form form={locationForm} layout="vertical" onFinish={handelAddressSubmit}>
            <Col md={24} sm={24}>
              <div
                style={{
                  margin: "20px 0px",
                  height: "300px",
                  overflow: "hidden",
                }}
              >
                <Map onLocationSelect={handleLocationSelect} />
              </div>
            </Col>
            <Row gutter={16}>
              <Col md={4} sm={24}>
                <Form.Item label="ID" name="PumpID">
                  <Input disabled value={selectedPumpID} />
                </Form.Item>
              </Col>

              <Col md={10} sm={24}>
                <Form.Item
                  label="Address Longitude"
                  name="Longitude"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the Longitude",
                    },
                  ]}
                >
                  <Input placeholder="Enter the Longitude" />
                </Form.Item>
              </Col>

              <Col md={10} sm={24}>
                <Form.Item
                  label="Address Latitude"
                  name="Latitude"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the Latitude",
                    },
                  ]}
                >
                  <Input placeholder="Enter the Latitude" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="text-right">
                  <Space wrap>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      htmlType="submit"
                    >
                      Submit Location
                    </Button>
                  </Space>
                </div>
              </Col>
            </Row>
          </Form>
        </Row>
      </Modal>
    </>
  );
};

export default PetrolPumps;
